module.exports = __webpack_public_path__ + "img/0Q3B7166_Black_MockedUp.b72d4357.jpg";